// FILE 31: src/pages/About.js
import React from 'react';
import { Helmet } from 'react-helmet-async';
import SectionHeader from '../components/ui/SectionHeader';
import './About.css';


const VALUES = [
  {
    icon: '🏆',
    title: 'Quality Assurance',
    text: 'Every tile is inspected against strict tolerance and colour-consistency standards before it reaches our warehouse. Only the finest materials bear the Arden name.',
  },
  {
    icon: '💡',
    title: 'Expert Guidance',
    text: 'Our design consultants are trained to help you navigate material selection, estimate quantities, and pair tiles with complementary finishes and grout colours.',
  },
  {
    icon: '🚚',
    title: 'Nationwide Delivery',
    text: 'We ship to all 48 contiguous states with freight-friendly packaging designed to eliminate breakage.',
  },
];


export default function About() {
  return (
    <div className="about-page">
      <Helmet>
        <title>About Arden Surfaces | Premium Tile — Garland, TX</title>
        <meta name="description" content="Arden Surfaces was founded in 2026, backed by 30+ years of tile manufacturing experience. Factory-direct premium tile from Garland, Texas." />
        <meta property="og:title" content="About Arden Surfaces" />
        <meta property="og:description" content="Premium tile distribution for Dallas, Texas. Factory-direct from our manufacturing team in India." />
        <meta property="og:url" content="https://www.ardensurfaces.com/about" />
      </Helmet>
      {/* Hero */}
      <section className="about-hero">
        <h1 className="about-hero__title" data-aos="fade-up">About Arden Surfaces</h1>
        <p className="about-hero__subtitle" data-aos="fade-up" data-aos-delay="120">
          Premium tile distribution from Garland, TX — since 2026
        </p>
      </section>

      {/* Our Story */}
      <section className="about-section about-section--alt">
        <div className="about-section__inner about-story__grid">
          <div className="about-story__text" data-aos="fade-right">
            <h2>Our Story</h2>
            <p>
              Arden Surfaces was founded in 2026, backed by over 30 years of
              tile manufacturing and sales experience in India. That deep
              expertise is the foundation of everything we do — bringing
              premium, factory-direct tile to homeowners, contractors, and
              designers in Dallas, Texas and the surrounding region.
            </p>
            <p>
              We design and manufacture our tiles in India, working with
              expert craftsmen and state-of-the-art production facilities to
              ensure every piece meets our rigorous standards for quality,
              consistency, and beauty. Every SKU in our catalog has been
              touched, tested, and approved by our team before it reaches
              your hands.
            </p>
            <p>
              Based in Dallas, Texas, we are a growing distributor serving
              homeowners, contractors, and designers in the region. We remain
              committed to our founding belief: extraordinary spaces begin with
              extraordinary surfaces.
            </p>
          </div>
          <div className="about-story__image" data-aos="fade-left">
            <img
              src="https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800&q=80"
              alt="Natural stone tile surface"
            />
          </div>
        </div>
      </section>


      {/* Our Values */}
      <section className="about-section about-section--alt">
        <div className="about-section__inner">
          <SectionHeader
            title="Our Values"
            subtitle="Three principles that guide every decision we make."
            align="center"
          />
          <div className="about-values__grid">
            {VALUES.map((v, i) => (
              <div key={v.title} className="about-value-card" data-aos="fade-up" data-aos-delay={i * 120}>
                <span className="about-value-card__icon" aria-hidden="true">
                  {v.icon}
                </span>
                <h3 className="about-value-card__title">{v.title}</h3>
                <p className="about-value-card__text">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}
